import React from "react";
import {List, ListItem} from "@mui/material";
import {TerminalReleaseItem} from "~/apps/packages/warehouse-closure/components/TerminalReleaseList/TerminalReleaseItem";
import {useGetTerminalReleaseList} from "~/apps/packages/warehouse-closure/hooks";
import {useHistory} from "react-router-dom";
import {TerminalReleaseShort, TerminalReleaseState} from "~/apps/packages/warehouse-closure/queries";
import {findScrollableNode, useBottomScrollListener} from "~/lib/useBottomScrollListener";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";


export type TerminalReleaseListProps = {
    states?: TerminalReleaseState[]
    query?: string
}


export const TerminalReleaseList = (props: TerminalReleaseListProps) => {
    const {states, query} = props;
    const history = useHistory();
    const {data, loading, fetchMore, canFetchMore} = useGetTerminalReleaseList({
        status: states,
        query: query
    });

    const setScrollableNode = useBottomScrollListener(() => {
        fetchMore();
    }, 50, 100, false);

    const handleItemClick = (item: Pick<TerminalReleaseShort, "id">) => {
        history.push(`/${encodeURI(item.id)}`);
    }

    const handleRef = (node) => {
        setScrollableNode(findScrollableNode(node));
    }

    return (
        <LoadingBox isInitialLoading={data == undefined} loading={loading} empty={data?.length == 0} placeholder={canFetchMore}>
            {data?.length > 0 && (
                <List ref={handleRef}>
                    {data?.map((item) => (
                        <ListItem onClick={() => handleItemClick(item)} key={item.id}>
                            <TerminalReleaseItem terminalRelease={item}/>
                        </ListItem>
                    ))}
                </List>
            )}
        </LoadingBox>
    );
}